import React from "react";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Banner.css";

const Banner = ({
  subtitle,
  title,
  description,
  buttonText,
  buttonLink,
  backgroundVideo, // 🎥 video
  backgroundImage, // 🖼 fallback image
  videoUrl
}) => {
  return (
    <section
      className="banner"
      style={{
        backgroundImage: !backgroundVideo && backgroundImage
          ? `url(${backgroundImage})`
          : "none"
      }}
    >
      {/* ✅ Show video only if provided */}
      {backgroundVideo && (
        <video
          className="banner-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <div className="container banner-content">
        <div className="text-box">
          <p className="banner-subtitle">{subtitle}</p>
          <h1
            className="banner-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p className="banner-description">{description}</p>
          <Link to={buttonLink} className="cta-btn">
            <h3>{buttonText}</h3>
          </Link>
        </div>

        {/* Optional Play Button */}
        {/* {videoUrl && (
          <a
            href={videoUrl}
            className="play-btn"
            target="_blank"
            rel="noreferrer"
          >
            <FaPlay />
          </a>
        )} */}
      </div>
    </section>
  );
};

export default Banner;
